import styles from './TemplateCardIllustration.module.scss'

const renderLines = count =>
  Array.from({ length: count }, (_, index) => (
    <span key={`line-${index}`} className={styles.line} />
  ))

const renderGallery = () => (
  <div className={styles.galleryGrid}>
    <span className={styles.galleryTile} />
    <span className={styles.galleryTile} />
    <span className={styles.galleryTile} />
    <span className={styles.galleryTile} />
  </div>
)

const renderColumns = () => (
  <div className={styles.columns}>
    <div className={styles.column}>
      <span className={styles.columnImage} />
      <span className={styles.lineShort} />
    </div>
    <div className={styles.column}>
      <span className={styles.columnImage} />
      <span className={styles.lineShort} />
    </div>
  </div>
)

const renderStacked = () => (
  <div className={styles.stacked}>
    <span className={styles.wideImage} />
    <span className={styles.lineShort} />
    <span className={styles.wideImage} />
    <span className={styles.lineShort} />
  </div>
)

const renderLinks = () => (
  <div className={styles.links}>
    <span className={styles.linkButton} />
    <span className={styles.linkButton} />
    <span className={styles.linkButton} />
  </div>
)

const renderCards = () => (
  <div className={styles.cards}>
    <span className={styles.cardTile} />
    <span className={styles.cardTile} />
    <span className={styles.cardTile} />
  </div>
)

const renderQuote = () => (
  <div className={styles.quoteBlock}>
    <span className={styles.line} />
    <span className={styles.lineShort} />
    <span className={styles.avatar} />
  </div>
)

const renderPremium = () => (
  <div className={styles.premium}>
    {renderLines(2)}
    <span className={styles.noteBlock} />
    <span className={styles.wideImage} />
    {renderCards()}
    {renderGallery()}
  </div>
)

const layoutRenderers = {
  default: () => (
    <>
      <span className={styles.hero} />
      {renderLines(3)}
      <span className={styles.button} />
    </>
  ),
  twoColumn: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      {renderColumns()}
    </>
  ),
  centeredHero: () => (
    <>
      <span className={styles.logoCentered} />
      <span className={styles.hero} />
      <div className={styles.centeredLines}>{renderLines(2)}</div>
      <span className={styles.buttonCentered} />
    </>
  ),
  labeled: () => (
    <>
      <span className={styles.kicker} />
      <span className={styles.hero} />
      {renderLines(3)}
      <span className={styles.button} />
    </>
  ),
  gallery: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      {renderGallery()}
      <span className={styles.button} />
    </>
  ),
  split: () => (
    <>
      <span className={styles.hero} />
      {renderLines(1)}
      {renderColumns()}
      <span className={styles.button} />
    </>
  ),
  wideHero: () => (
    <>
      <span className={styles.heroLarge} />
      {renderLines(2)}
      <span className={styles.button} />
    </>
  ),
  slideshow: () => (
    <>
      <span className={styles.heroSlideshow} />
      {renderLines(2)}
      <span className={styles.button} />
    </>
  ),
  messageGallery: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      <span className={styles.button} />
      {renderGallery()}
    </>
  ),
  stacked: () => (
    <>
      <span className={styles.hero} />
      {renderLines(1)}
      {renderStacked()}
      <span className={styles.button} />
    </>
  ),
  minimal: () => (
    <>
      <span className={styles.logoSmall} />
      <span className={styles.heroSmall} />
      {renderLines(3)}
      <span className={styles.button} />
    </>
  ),
  zigzag: () => (
    <>
      <span className={styles.hero} />
      {renderLines(1)}
      <div className={styles.zigzagRow}>
        <span className={styles.columnImage} />
        <span className={styles.lineShort} />
      </div>
      <div className={styles.zigzagRowReverse}>
        <span className={styles.lineShort} />
        <span className={styles.columnImage} />
      </div>
    </>
  ),
  discover: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      {renderLinks()}
    </>
  ),
  dualCta: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      <span className={styles.button} />
      <span className={styles.buttonOutline} />
    </>
  ),
  galleryCaptions: () => (
    <>
      <span className={styles.hero} />
      {renderLines(1)}
      {renderGallery()}
      <span className={styles.button} />
    </>
  ),
  lifestyle: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      <span className={styles.wideImage} />
      <span className={styles.button} />
    </>
  ),
  personal: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      <span className={styles.noteBlock} />
      <span className={styles.button} />
    </>
  ),
  testimonial: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      {renderQuote()}
      <span className={styles.button} />
    </>
  ),
  experiences: () => (
    <>
      <span className={styles.hero} />
      {renderLines(2)}
      {renderCards()}
      <span className={styles.button} />
    </>
  ),
  editorial: () => (
    <>
      <span className={styles.logoCentered} />
      <span className={styles.kicker} />
      <span className={styles.heroArch} />
      {renderLines(2)}
      <span className={styles.buttonOutline} />
      {renderStacked()}
    </>
  ),
  resort: () => (
    <>
      <span className={styles.logoCentered} />
      <span className={styles.hero} />
      <div className={styles.centeredLines}>{renderLines(2)}</div>
      <span className={styles.button} />
      <span className={styles.wideImage} />
      {renderLinks()}
      {renderGallery()}
      <span className={styles.logoCentered} />
    </>
  ),
  premium: () => (
    <>
      <span className={styles.heroLarge} />
      {renderPremium()}
      <span className={styles.button} />
    </>
  )
}

export const TEMPLATE_CARD_LAYOUTS = {
  default: 'default',
  twoColumn: 'twoColumn',
  centeredHero: 'centeredHero',
  introKickerBody: 'labeled',
  galleryShowcase: 'gallery',
  splitHighlight: 'split',
  wideHero: 'wideHero',
  heroSlideshow: 'slideshow',
  bodyThenGallery: 'messageGallery',
  stackedStory: 'stacked',
  minimalDirect: 'minimal',
  zigZagColumns: 'zigzag',
  discoverLinks: 'discover',
  editorialEvent: 'editorial',
  resortDiscovery: 'resort',
  galleryWithCaptions: 'galleryCaptions',
  lifestyleBreak: 'lifestyle',
  personalNote: 'personal',
  socialProof: 'testimonial',
  experienceCards: 'experiences',
  premiumDirect: 'premium'
}

const TemplateCardIllustration = ({ templateKey, compact = false }) => {
  const layoutKey = TEMPLATE_CARD_LAYOUTS[templateKey] || 'default'
  const renderLayout = layoutRenderers[layoutKey] || layoutRenderers.default

  return (
    <div
      className={[styles.illustration, compact ? styles.illustrationCompact : '']
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      <span className={styles.headerBar} />
      {renderLayout()}
    </div>
  )
}

export default TemplateCardIllustration
